import React from "react";
import { 
    ResponsiveContainer, 
    LineChart, 
    Line, 
    XAxis, 
    YAxis, 
    CartesianGrid, 
    Tooltip 
} from "recharts";

const LineChartBase = ({ 
    data, 
    xKey, 
    yKey, 
    height = 220, 
    stroke = "#8b5cf6",
    yFormatter,         
    tooltipFormatter, 
    domain,
    padding,
    textSize=12,
}) => {

  return (
    <div style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart 
            data={data} 
            margin={{ top: 5, right: 12, left: 12, bottom: 5 }}
        >
          <CartesianGrid 
            strokeDasharray="3 3" 
            stroke="var(--chart-grid)"

          />
          <XAxis 
            dataKey={xKey} 
            tick={{ fill: "var(--chart-tick)", fontSize: textSize }}
            axisLine={{ stroke: "var(--chart-axis)" }}
            tickLine={{ stroke: "var(--chart-axis)" }}
          />
          <YAxis 
            tick={{ fill: "var(--chart-tick)", fontSize: textSize }}
            axisLine={{ stroke: "var(--chart-axis)" }}
            tickLine={{ stroke: "var(--chart-axis)" }}
            {...(domain ? { domain } : {})}
            tickFormatter={yFormatter}
            padding={padding}  
          />
          <Tooltip
              cursor={{ fill: "var(--chart-tooltip-cursor)" }}
              contentStyle={{
                backgroundColor: "#ffffff",
                border: "1px solid #e2e8f0",
                borderRadius: 8,
                fontSize: textSize,
                color: "#000000"
              }}
              itemStyle={{ color: "#000000" }}
              labelStyle={{ color: "#000000" }}
              formatter={tooltipFormatter}
          />
          <Line 
            type="monotone" 
            dataKey={yKey} 
            stroke={stroke} 
            strokeWidth={3} 
            dot={{ r: 5, fill: "#8b5cf6" }} 
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LineChartBase;
